/* "Clínicamente probado": el contexto en un panel de fila.
   (Mau, 2026-08-18 — diseño 2 de la maqueta "Cómo abre el contexto".)

   Problema que resuelve: con el texto dentro de su tarjeta, abrir una
   métrica del 2x2 estiraba a su vecina (bloque gris muerto) o, si la
   abierta se ensanchaba, empujaba a la vecina a otra fila. Mau quiere que
   las cuatro se queden QUIETAS y que solo se despliegue el texto, a lo
   ancho de las dos columnas y por debajo de la pareja.

   Mejora progresiva: el HTML sigue siendo <details> nativo y sin este
   script la sección funciona como siempre (el texto se abre dentro de la
   tarjeta). Aquí se marca el grid con `is-panel` — el CSS entonces
   esconde el texto interior — y se pinta en el panel de su fila, con la
   flechita apuntando a la columna de la que salió.

   Solo una métrica abierta a la vez: dos paneles abiertos en un 2x2
   dejaban la sección larguísima en móvil. */
(function () {
  'use strict';

  var grid = document.querySelector('[data-pcp-grid]');
  if (!grid) return;

  var metricas = [].slice.call(grid.querySelectorAll('details[data-pcp-metric]'));
  var paneles = [].slice.call(grid.querySelectorAll('[data-pcp-panel]'));
  if (!metricas.length || !paneles.length) return;

  grid.classList.add('is-panel');

  /* El panel de una métrica es el de su fila: 2 por fila en el 2x2. */
  function panelDe(metrica) {
    var todas = [].slice.call(grid.querySelectorAll('[data-pcp-metric]'));
    var i = todas.indexOf(metrica);
    return paneles[Math.floor(i / 2)] || paneles[paneles.length - 1];
  }

  function columnaDe(metrica) {
    var todas = [].slice.call(grid.querySelectorAll('[data-pcp-metric]'));
    return todas.indexOf(metrica) % 2 === 0 ? 'izq' : 'der';
  }

  function cerrarPaneles() {
    for (var i = 0; i < paneles.length; i++) {
      paneles[i].hidden = true;
      paneles[i].textContent = '';
    }
  }

  function abrir(metrica) {
    var texto = metrica.querySelector('.pcp__detail');
    var figura = metrica.querySelector('.pcp__figure');
    var etiqueta = metrica.querySelector('.pcp__label');
    if (!texto) return;

    var panel = panelDe(metrica);
    cerrarPaneles();

    /* createElement + textContent, nunca innerHTML: el copy viene de los
       settings y puede llevar cualquier carácter. */
    var quien = document.createElement('span');
    quien.className = 'pcp__panel-quien';
    quien.textContent =
      (figura ? figura.textContent.trim() : '') +
      (etiqueta ? ' · ' + etiqueta.textContent.trim() : '');

    var cuerpo = document.createElement('span');
    cuerpo.className = 'pcp__panel-texto';
    cuerpo.textContent = texto.textContent.trim();

    panel.appendChild(quien);
    panel.appendChild(cuerpo);
    panel.setAttribute('data-lado', columnaDe(metrica));
    panel.hidden = false;
  }

  metricas.forEach(function (metrica) {
    metrica.addEventListener('toggle', function () {
      if (metrica.open) {
        /* Una sola abierta: cerrar las demás dispara su propio toggle,
           que entra por la rama de abajo y limpia paneles; por eso se
           cierran ANTES de pintar el nuevo. */
        metricas.forEach(function (otra) {
          if (otra !== metrica && otra.open) otra.open = false;
        });
        abrir(metrica);
      } else if (!metricas.some(function (m) { return m.open; })) {
        cerrarPaneles();
      }
    });
  });
})();
